import React, { lazy } from 'react';
import { Route } from 'react-router';
import { PERMISSIONS } from '@auth/permissions';
import { RequirePermission } from '@routes/RequirePermission';

const AboutAssociation = lazy(() =>
  import('@pages/Management/Association/about/AboutDetails').then((m) => ({
    default: m.AboutAssociation,
  }))
);

const EditAbout = lazy(() =>
  import('@pages/Management/Association/about/EditAbout').then((m) => ({
    default: m.EditAbout,
  }))
);

const InstructionsOverview = lazy(() =>
  import('@pages/Management/Association/instructions/InstructionsOverview').then(
    (m) => ({
      default: m.InstructionsOverview,
    })
  )
);

const InstructionDetails = lazy(() =>
  import('@pages/Management/Association/instructions/InstructionDetails').then(
    (m) => ({
      default: m.InstructionDetails,
    })
  )
);

const EditInstruction = lazy(() =>
  import('@pages/Management/Association/instructions/EditInstruction').then(
    (m) => ({
      default: m.EditInstruction,
    })
  )
);

const CreateInstruction = lazy(() =>
  import('@pages/Management/Association/instructions/CreateInstruction').then(
    (m) => ({
      default: m.CreateInstruction,
    })
  )
);

const RulesAndRegulationPageOverview = lazy(() =>
  import('@pages/Management/Association/rules-and-regulations/RulesAndRegulationPageOverview').then(
    (m) => ({
      default: m.RulesAndRegulationPageOverview,
    })
  )
);

const EditRulesAndRegulationPage = lazy(() =>
  import('@pages/Management/Association/rules-and-regulations/EditRulesAndRegulationPage').then(
    (m) => ({
      default: m.EditRulesAndRegulationPage,
    })
  )
);

const CreateRulesAndRegulationPage = lazy(() =>
  import('@pages/Management/Association/rules-and-regulations/CreateRulesAndRegulationPage').then(
    (m) => ({
      default: m.CreateRulesAndRegulationPage,
    })
  )
);

const RulesAndRegulationPageDetails = lazy(() =>
  import('@pages/Management/Association/rules-and-regulations/RulesAndRegulationPageDetails').then(
    (m) => ({
      default: m.RulesAndRegulationPageDetails,
    })
  )
);

const ManageBoardMembers = lazy(() =>
  import('@pages/Management/Association/ManageBoardMembers').then((m) => ({
    default: m.ManageBoardMembers,
  }))
);

const ManageWeaponGroups = lazy(() =>
  import('@pages/Management/Association/ManageWeaponGroups').then((m) => ({
    default: m.ManageWeaponGroups,
  }))
);

const AssociationLandingPage = lazy(() =>
  import('./landingPages/AssociationLandingPage').then((m) => ({
    default: m.AssociationLandingPage,
  }))
);

export const manageAssociationRoutes = (
  <Route path="association">
    <Route index element={<AssociationLandingPage />} />

    {/* ABOUT */}
    <Route
      element={
        <RequirePermission permission={PERMISSIONS.association.about.view} />
      }
    >
      <Route path="about" element={<AboutAssociation />} />

      <Route
        element={
          <RequirePermission
            permission={PERMISSIONS.association.about.update}
          />
        }
      >
        <Route path="about/edit" element={<EditAbout />} />
      </Route>
    </Route>

    {/* INSTRUCTIONS */}
    <Route
      element={
        <RequirePermission
          permission={PERMISSIONS.association.instructions.view}
        />
      }
    >
      <Route path="instructions">
        <Route index element={<InstructionsOverview />} />

        <Route
          element={
            <RequirePermission
              permission={PERMISSIONS.association.instructions.update}
            />
          }
        >
          <Route path="edit/:id" element={<EditInstruction />} />
        </Route>

        <Route
          element={
            <RequirePermission
              permission={PERMISSIONS.association.instructions.create}
            />
          }
        >
          <Route path="new" element={<CreateInstruction />} />
        </Route>

        <Route
          element={
            <RequirePermission
              permission={PERMISSIONS.association.instructions.delete}
            />
          }
        >
          <Route path=":id" element={<InstructionDetails />} />
        </Route>
      </Route>
    </Route>

    {/* RULES & REGULATIONS */}
    <Route
      element={
        <RequirePermission
          permission={PERMISSIONS.association.rulesAndRegulationsPage.view}
        />
      }
    >
      <Route path="regulations-and-safety">
        <Route index element={<RulesAndRegulationPageOverview />} />

        <Route
          element={
            <RequirePermission
              permission={
                PERMISSIONS.association.rulesAndRegulationsPage.update
              }
            />
          }
        >
          <Route path="edit/:id" element={<EditRulesAndRegulationPage />} />
        </Route>

        <Route
          element={
            <RequirePermission
              permission={
                PERMISSIONS.association.rulesAndRegulationsPage.update
              }
            />
          }
        >
          <Route path="new" element={<CreateRulesAndRegulationPage />} />
        </Route>

        <Route
          element={
            <RequirePermission
              permission={
                PERMISSIONS.association.rulesAndRegulationsPage.delete
              }
            />
          }
        >
          <Route path=":id" element={<RulesAndRegulationPageDetails />} />
        </Route>
      </Route>
    </Route>

    {/* BOARD MEMBERS */}
    <Route
      element={
        <RequirePermission
          permission={PERMISSIONS.association.boardMembers.view}
        />
      }
    >
      <Route path="board-members" element={<ManageBoardMembers />} />
    </Route>

    <Route
      element={
        <RequirePermission
          permission={PERMISSIONS.association.weaponGroups.view}
        />
      }
    >
      <Route path="weapon-groups" element={<ManageWeaponGroups />} />
    </Route>
  </Route>
);
